/**
 * A message's secondary controls — Edit and Delete on the reader's own, Mark Unread on one already read —
 * stay out of sight until the reader points at the message or tabs into it. Drawn under every message,
 * two pencils and two bins in a row of four messages were most of what the pane showed.
 *
 * A screen with no pointer that hovers has no way to reveal them, so there they always show. They are
 * hidden with opacity, not `display`, so they keep their place in the tab order and in the row.
 */
export const HOVER_ACTION_CLASS = "MessageHoverAction";

/** The rules a message's container carries, so the hover actions inside it show on hover or focus. */
export const revealHoverActions = {
  [`& .${HOVER_ACTION_CLASS}`]: {
    opacity: 0,
    transition: "opacity 120ms ease-out",
  },
  [`&:hover .${HOVER_ACTION_CLASS}, &:focus-within .${HOVER_ACTION_CLASS}`]: {
    opacity: 1,
  },
  "@media (hover: none)": {
    [`& .${HOVER_ACTION_CLASS}`]: {
      opacity: 1,
    },
  },
};
